/*
 * Copyright (c) 2018 Well Solutions SRL. All Rights Reserved.
 * This software is the proprietary information of Well Solutions SRL.
 * Use is subject to license and non-disclosure terms
 */

export const ro = {
  "error": {
    "403": "You are not authorized to access the page.",
    "title": "Error page!",
    "internalServerError": "Internal server error",
    "server.not.reachable": "Server not reachable",
    "url.not.found": "Not found",
    "NotNull": "Field {{ fieldName }} cannot be empty!",
    "Size": "Field {{ fieldName }} does not meet min/max size requirements!",
    "userexists": "Login name already used!",
    "emailexists": "Email is already in use!",
    "idexists": "A new {{ entityName }} cannot already have an ID",
    "unauthorized": 'Actiune neautorizata',
    "bad-credentials": 'Datele de autentificare introduse sunt incorecte, Verificati datele si incercati din nou',
    "error.validation": 'Eroare de validatre',
    'defaultError': 'A aparut o eroare',
  }
};
